// extracted by mini-css-extract-plugin
module.exports = {"scroll-container":"MegaMenu_scroll-container__jpwVq","scroll-container-dark":"MegaMenu_scroll-container-dark__zndCr"};